/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Side menu component
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.11.0
 */

import { FC } from 'react';

import { SideMenuStyled } from './styled/SideMenuStyled';

export interface ISideMenu {
    width?: number;
}

const SideMenu: FC<ISideMenu> = props => {

    const {
        children,
        width,
    } = props;

    return (
        <SideMenuStyled width={width ? `${width}px` : '100%'}>
            { children }
        </SideMenuStyled>
    );
};

export default SideMenu;
